import React from 'react'
import './App.css';
import MyNavbar from './components/my-navbar/mynavbarcomp'
import MyCarousal from './components/my-carousel/mycarouselcomp'
import TitleMessage from './components/title-message/titleMessageComp'
import About from './pages/about/aboutcomp'
import {Parallax} from 'react-parallax'
import Container from 'react-bootstrap/Container'
import Fade from 'react-reveal/Fade'
import Bg from './assets/parallax/img/background.webp'
import Skill from './pages/skills/skillscomp.jsx'
import Experience from './pages/experience/experiencecomp'
import Slide from 'react-reveal/Slide'
import ProjectTimeline from './components/project-timeline/projecttimeline'
import Contact from './pages/contact-form/contactform'
import Particles from 'react-particles-js'
import {particlesOption} from './particlesOption'


function App() {
  return (
    <div className="App" style={{position: 'relative'}}>
      <MyNavbar />
      <MyCarousal />
      <TitleMessage />
      <Particles className='particles particles-box' params={particlesOption} />
      <div>
        <Parallax blur={{ min: -30, max: 30 }}
          bgImage={Bg}
          bgImageAlt=""
          strength={-200}>
            <div>
              <Container className="container-box rounded">
                <Fade duration={2500}>
                  <About />
                </Fade>
              </Container>
            </div>
          </Parallax>
      </div>
      <div>
        <Container className="container-box rounded">
            <Slide duration={2500}>
              <hr/>
              <Skill />
            </Slide>
        </Container>
      </div>
      <div>
          <Container className="container-box rounded">
            <Fade duration={2500}>
                <hr/>
                <Experience />
            </Fade>
          </Container>
      </div>
      <div>
        <Container className="container-box rounded">
            <Slide duration={2500}>
              <hr/>
              <ProjectTimeline />
            </Slide>
        </Container>
      </div>
      <div>
          <Container className="container-box rounded">
            <Fade duration={2500}>
                <hr/>
                <Contact />
            </Fade>
          </Container>
      </div>
    </div>
  );
}

export default App;
